import PaymentsTable from "./components/Payments";
import { useParams } from "react-router-dom";
import Debits from "./components/Debits";

export default function PaymentsOutlet() {
  const { subMenu } = useParams();

  switch (subMenu) {
    case "payment":
      return <PaymentsTable />;
    case "debits":
      return <Debits />;
    default:
      return <PaymentsTable />;
  }
}
